import React from 'react';
import type { HeroTemplateProps } from '../../types';

/** Ecommerce Collapse: no hero imagery — layout lives in the header stack. */
const HeroEcommerce: React.FC<HeroTemplateProps> = () => null;

export default HeroEcommerce;
